export const commonTR = {
    first: "Birinci",
    second: "İkinci",
    third: "Üçüncü",
    fourth: "Dördüncü",
    fifth: "Beşinci",
    sixth: "Altıncı",
    seventh: "Yedinci",
    eighth: "Sekizinci",
    other: "Diğer",
    freeGift: "Ücretsiz hediye",
  "firstName": "Ad",
  "lastName": "Soyad",
  "street": "Sokak",
  "streetNumber": "Numara",
  "city": "Şehir",
  "origin": "Bölge",
  "postcode": "Posta Kodu",
  "phone": "Telefon Numarası",
  "apartment": "Daire",
  "email": "E-posta",
  "emailMessage": "E-postanızı asla başkasıyla paylaşmayacağız",
  "checkout": "Ödeme",
  "streetAndNumber": "Sokak & Numara",
  "privacyStatement": "Gizlilik Politikası",
  "termsOfService": "Hizmet Şartları",
  "termsOfServiceNoun": "Hizmet Şartları",
  "aboutUs": "Hakkımızda",
  "product": "Ürün",
  "products": "Ürünler",
  "subTotal": "Ara Toplam",
  "transportation": "Nakliye Ücreti",
  "total": "Toplam",
  "price": "Fiyat",
  "quantity": "Adet",
  "items": "Ürünler",
  "firstNameError": "Lütfen bir ad girin",
  "lastNameError": "Lütfen bir soyad girin",
  "phoneError": "Lütfen geçerli bir telefon numarası girin",
  "emailError": "Lütfen geçerli bir e-posta adresi girin",
  "save": "KAYDET",
  "updateSuccess": "Güncelleme başarılı oldu",
  "updateError": "Güncelleme hatası",
  "updated": "Güncellendi!",
  "cartUpdated": "Alışveriş sepetiniz başarıyla güncellendi!",
  "wishlistUpdated": "İstek listesiniz başarıyla güncellendi!",
  "streetError": "Lütfen bir sokak adı girin",
  "streetNumberError": "Lütfen bir sokak numarası girin",
  "cityError": "Lütfen bir şehir girin",
  "order": "Sipariş",
  "logout": "Çıkış Yap",
  "warning": "UYARI",
  "logoutWarning": "Çıkış yapmak istediğinizden emin misiniz?",
  "yes": "EVET",
  "no": "HAYIR",
  "loginRegistration": "Giriş/Kayıt",
  "login": "GİRİŞ YAP",
  "passwordHelperText": "en az 8 karakter, rakam, büyük ve küçük harf içermeli",
  "forgotPassword": "Şifremi Unuttum?",
  "or": "veya",
  "facebookLogin": "FACEBOOK İLE GİRİŞ YAP",    
  "googleLogin": "GOOGLE İLE GİRİŞ YAP",
  "register": "Kayıt",
  "registerButton": "YENİ MÜŞTERİ",
  "exit": "ÇIKIŞ",
  "resetPassword": "Şifreyi Sıfırla",
  "resetPasswordInfoA": "Lütfen e-postanızı girin",
  "resetPasswordInfoB": "ve yeni bir şifre alacaksınız.",
  "registerA": "KAYIT OL",
  "registerInfoA": "Kaydım ile birlikte,",
  "registerInfoB": "genel hizmet şartlarını",
  "registerInfoC": ",",
  "registerInfoD": "Gizlilik Politikasını",
  "registerInfoE": "ve",
  "registerInfoF": "tekliflerin hizmet şartlarını kabul ediyorum",
  "verificationCode": "Doğrulama Kodu",
  "verificationInfo": "Lütfen şu adrese gönderilen 4 haneli kodu girin:",
  "enterCode": "Kodu Girin",
  "errorCode": "Yanlış Doğrulama Kodu, Lütfen tekrar deneyin",
  "codeExpired": "Bu kodun süresi doldu veya çok fazla denendi. Yeni bir kod isteyin.",
  "codeTooSoon": "Az önce bir kod gönderildi. Yeni bir kod istemeden önce lütfen bir dakika bekleyin.",
  "codeLocked": "Bu e-posta için çok fazla deneme yapıldı. Lütfen daha sonra tekrar deneyin.",
  "codeEmailTaken": "Bu e-posta ile kayıtlı bir hesap zaten var. Giriş yapın veya şifrenizi sıfırlayın.",
  "codeAlreadyDone": "Hesabınız hazır. Lütfen giriş yapın.",
  "codeResent": "E-postanıza yeni bir kod gönderildi.",
  "codeSendLimit": "Bu kayıt için daha fazla kod gönderilemez. Aldığınız son kodu girin veya yeniden kayıt olun.",
  "codeRegisterAgain": "Bu kayıt artık geçerli değil. Lütfen yeniden kayıt olun.",
  "codeNoAnswer": "Mağazadan yanıt yok. Bağlantınızı kontrol edip tekrar deneyin.",
  "repeat": "TEKRAR GÖNDER",
  "youSee": "Görüntülüyorsunuz",
  "from": "/",
  "stockWarning": "Maalesef seçtiğiniz ürün stokta bulunmamaktadır!",
  "leaveAComment": "Yorum bırakın...",
  "saveReview": "Yorumu Kaydet",
  "reviews": "Yorumlar",
  "qrCodeBuy": "Mobilinizden tek tıkla hızlı ve kolay alışveriş yapın!",
  "qrCodeScanAndroid": "Android uygulamamızı indirmek için tarayın",
  "qrCodeDownload": "Android için uygulamamızı indirin",
  "qrCodeBuyMobile": "Hem Android hem iOS için restoran uygulamamızı indirin ve mobilinizden istediğiniz zaman sipariş verin!",    
  "qrCodeScanIos": "iOS uygulamamızı indirmek için tarayın",    
  "qrCodeForAndroid": "Android için",
  "qrCodeForIos": "iOS için",    
  "photoUpload": "Fotoğraf Yükleme",    
  "edit": "DÜZENLE",
  "delete": "SİL",
  "addCart": "Sepete Ekle",
  "noEvaluation": "Henüz değerlendirme yok.",
  "onlyLoggedInCustomers": "Sadece ürünü satın almış giriş yapmış müşteriler yorum yazabilir.",
  "beTheFirstReview": "Bu ürün için ilk yorumu yazan siz olun.",
  "seeMoreProducts": "Daha fazla ürün görüntüle",
  "favorite": "FAVORİLER",
  "favorites": "Favoriler",
  "noFavoritesYet": "Henüz favori ürününüz yok",
  "deleteProduct": "Bu ürünü silmek istediğinizden emin misiniz?",
  "deleteProduct1": "Bu ürünü silmek istediğinizden emin misiniz",
  "fromCart": "sepetten?",
  "deleteAddress": "Adresi silmek istediğinizden emin misiniz?",
  "danger": "UYARI",
  "connectionIssue": "Dikkat! Sipariş gönderimi başarısız oldu. Lütfen bağlantınızı kontrol edin.",
  "sendOrder": "Siparişi Gönder",
  "pleaseWait": "Lütfen bekleyin...",
  "noMoreProductsInStock": "Stoktan daha fazla ürün sepete ekleyemezsiniz",
  "productAddedCart": "Ürün sepetinize eklendi!",
  "home": "Ana Sayfa",
  "myAccount": "Hesabım",
  "ckeckout": "ÖDEME",
  "all":"Tümü",
  "signIn":"Giriş Yap",
  "search": "Ara",
  "productSKU": "SKU",
  "productSKUFull": "Ürün SKU:",
  "language": "Dil",
  "size": "BEDEN",
  "extra": "Ekstra",
  "removeIngredients": "Malzemeleri çıkar",    
  "status": "Durum",
  "searchResults": "Arama Sonuçları",
  "noResults": "SONUÇ BULUNAMADI",
  "dailyProducts": "Günün Ürünleri",
  "offersText": "Günlük teklifler",
  "popularText": "En Popüler",
  "productComments": "Bir yorum veya özel istek girin (İsteğe Bağlı)",
  "weighted": "Ağırlıklı Ürün",
  "kgr": "Kg Fiyatı",
  "without": "OLMAKSIZIN",
  "noSuchUser": "Bu e-posta ile kayıtlı kullanıcı bulunamadı!",
  "reset": "Sıfırla.",
  "lostPassword": "Şifrenizi mi unuttunuz? ",
  "loginOr": "veya ile giriş yap",
  "here": "buradan",
  "orRegister": "Hesabınız yok mu? Kayıt olun ",
  "stockWarningHeader": "Stok Uyarısı",
  "duplicateEmail": "Bu e-posta başka bir hesap tarafından kullanılıyor. Lütfen giriş yapmayı deneyin.",
  "cartUpdatedAlert": "Sepet güncellendi",
  "wishlistUpdatedAlert": "İstek listesi güncellendi",
  "watchThis": "Bunlara göz atın!",
    composition: "Bileşim",
  "pickSize": "Bir beden seçin",
  "addExtra": "Ekstra malzeme ekle",
  "logoutAccount": "Hesaptan Çıkış Yap",
  "deleteAccount": "Hesabı Sil",
  "deleteAccountMessage": "Hesabınızı silmek istediğinizden emin misiniz?",
  "yesSmall": "Evet",
  "noSmall": "Hayır",
  "show": "Sepeti Göster",
  "removeItem": "Ürünü Kaldır",
  "youSure": "Emin misiniz?",
  "cancel": "İptal",
  "scannerError": "Tarama sırasında hata oluştu. Lütfen tekrar deneyin.",
  "scannerSuccess": "Hoş Geldiniz",    
  "scannerMessage": "Masada misafir olarak devam edin",
  "companyOrigin": "Ana Bölge",
  "addNewAddress": "Yeni adres ekle",
  "holidayText": "Mekan bugün kapalı olacaktır",
  "minimumOrderHeader": "Minimum Sipariş",
  "minimumOrder": "Minimum sipariş tutarı ",
  "appleId": "Bu e-posta Apple ile giriş için kullanılmış",
  "facebookId": "Bu e-posta Facebook ile giriş için kullanılmış",
  "googleId": "Bu e-posta Google ile giriş için kullanılmış",
  "emailPassword": "Bu e-posta e-posta ve şifre ile giriş için kullanılmış",
  "loginError": "Giriş Hatası: ",
  "discount": "İndirim",
  "to": "Açılış Saati",
  "openingTime": "Çalışma Saatleri",    
  "more": "Daha Fazla",
  "lastAddress": "Son adres silinemez",
  "updateFailure": "Güncelleme başarısız oldu",
  "succesDeleteAddress": "Adres başarıyla silindi.",
  "noCategoryItemsYet": "Bu kategoride aktif ürün bulunmamaktadır.",
  "reserveTable": "Masa rezervasyonu",
  "reserveTableUC": "MASa REZERVASYONU",
  "yourReservation": "Rezervasyonunuz",
  "chooseHour": "Saat seçin",
  "bookingComment": "Özel istek ekleyin (isteğe bağlı)",
  "party": "Misafir",
  "pickDate": "Tarih Seçin",
  "partyOf": "Toplam ",
  "date": "Tarih",
  "hour": "Saat",
  "customerDiscount": "Müşteri indirimi",
  "couponDiscount": "İndirim kuponu",
  "voucherTitle": "Değeri ",
  "applyVoucher": "Bu kuponu alışveriş sepetinize uygulayın.",
  "copy": "Kopyala",
  "minimumVoucherOrder": "Minimum Sipariş",
  "minimumVoucherCaption": "İndiriminizi uygulamak için gereken minimum sipariş tutarı",
  voucherNotApplied: "Kupon uygulanmadı",
  voucherInvalid: "Bu kod geçerli değil.",
  voucherExpired: "Bu kodun süresi dolmuş.",
  voucherFirstOrderOnly: "Yalnızca ilk siparişinizde geçerlidir, hesapla.",
  "loyaltyTitle": "Sadakat ödülleri",
  "loyaltyCaption": "Toplam değeri olan sadakat ödülleri kazandınız",
  "loyaltySubCaption": "Ödeme sırasında otomatik olarak indirim uygulanacaktır.",
  "loyaltyMoto": "İndirim kazanmak için sipariş vermeye devam edin",
  "endsIn": "Bitiş",
  "days": "gün",
  "table": "MASA",
  "comments": "YORUMLAR",
  "dateCut": "Tarih",
  "newOrder": "YENİ SİPARİŞ",
  "num": "S/N",
  "extras": "EKSTRALAR",
  "tableOrder": "MASA",
  "phoneDelivery": "TELEFON TESLİMAT",
  "phoneTakeAway": "TELEFON PAKET SERVİS",
  "webDelivery": "WEB TESLİMAT",
  "webTakeAway": "WEB PAKET SERVİS",
  "webTable": "WEB-QR MASA",
  "appDelivery": "UYGULAMA TESLİMAT",
  "appTakeAway": "UYGULAMA PAKET SERVİS",
  "appTable": "UYGULAMA-QR MASA",
  "enterTip": "Bahşiş Girin",
  "tip": "Bahşiş",  
  "apply": "Uygula",
  "textTotal": "Toplam Ödeme",  

  "successfulPayment": "Başarılı ödeme",
  "unsuccessfulPayment": "Başarısız ödeme",
  "payment": "Ödeme",
  "confirmation": "Onay",
  "tryAgain": "Tekrar deneyin",

  "appliedDiscounts": "Uygulanan indirimler",
  "productName": "Ürün adı",
  "totalPrice": "Toplam fiyat",
  "firstname": "Ad",
  "lastname": "Soyad",
  
  "postCode": "Posta Kodu",
  "invoiceAddress": "Fatura Adresi",
  "otherAddress": "Teslimat Adresi",
  "afm": "Vergi No",
  "doy": "Vergi Dairesi",
  "occupation": "Meslek",
  "invoiceData": "Fatura bilgileri",
  "yourOrder": "Siparişiniz",
  "withNumber": "numaralı",
  "dear": "Sayın",
  "orderTotalAmount": "Siparişinizin toplam tutarı",
  "orderDelivery": "Siparişiniz en kısa sürede teslim edilecektir.",
  "thanks": "Tercihiniz için teşekkür ederiz",
  "customer": "Müşteri",
  "youReceived": "Numaralı siparişi aldınız",
  "congrats": "Siparişiniz için tebrikler",
  "newOrderWith": "Numaralı yeni sipariş",
  
  "orderingComments": "Sipariş yorumları",
      "selectSmall": "Seç",
   delivery: "Teslimat",
    "course": "Kurs",
    view: "GÖRÜNTÜLE",
    "outOfStock": "Stokta yok",
    emailConfirmationCode: "Doğrulama Kodu",
    emailCodeIs: "4 haneli doğrulama kodunuz",
    emailPasswordReset: "Şifre Sıfırlama",
    emailNewPassword: "Yeni şifreniz",
    emailLoginInfo: "E-postanız ve yeni şifrenizle giriş yapabilirsiniz",
    emailChangePassword: "Ardından kendi şifrenizle değiştirebilirsiniz",
    partOf: "Parcasi",
    errorTitle: "Bir şeyler ters gitti",
    errorMessage: "Bu sayfada beklenmeyen bir hata oluştu. Tekrar deneyebilir veya ana sayfaya dönebilirsiniz.",
    goToHome: "Ana sayfaya git",
    colorThemeLight: "Açık tema",
    colorThemeDark: "Koyu tema",
    colorThemeSystem: "Sistem teması",
    skipToContent: "İçeriğe geç",
    mainMenu: "Ana menü",
    grams: "g",
    addressTooFar: "Bu adres işletmeden çok uzak görünüyor, lütfen kontrol edin.",
    addressPickArea: "Adres bulundu, lütfen aşağıdan bölgenizi seçin.",
    addressLookupFailed: "Adres bilgileri alınamadı, lütfen adresi elle yazın.",
    trackOrder: "Siparişi takip et",
    orderStatus: "Sipariş durumu",
    trackingUnavailable: "Bu sipariş için canlı takip mevcut değil.",
    courierEnRoute: "Kurye yolda",
    courierLastSeen: "Kuryenin son görülme saati",
    courierNoPosition: "Siparişiniz kuryede.",
    orderStatusPending: "Beklemede",
    orderStatusProcessing: "Hazırlanıyor",
    orderStatusCompleted: "Hazır",
    orderStatusDelivering: "Yolda",
    orderStatusDelivered: "Teslim edildi",
    adjustPinHint: "İşaretçiyi tam giriş kapınıza sürükleyin",
    updateAddress: "Adresi güncelle",
    addressPinSaved: "Konum güncellendi.",
    paymentUnconfirmedTitle: "Ödeme henüz onaylanmadı",
    paymentUnconfirmed: "Ödemenizi bankayla henüz doğrulayamadık, bu nedenle siparişiniz gönderilmedi. Tekrar denemek yalnızca yeniden kontrol eder; kartınızdan tekrar ücret alınmaz.",
    paymentNotVerified: "Kartla ödemeniz doğrulanamadı, bu nedenle sipariş verilmedi.",
}